<div *ngIf="isLoggedIn" class="wrapper" (click)="handleFavorite($event)">
  <div *ngIf="full" class="label">Favorite</div>

  <app-shared-icon
    *ngIf="!full && !property?.isFavorite"
    name="favorite-heart"
    [size]="iconSize"
  ></app-shared-icon>

  <app-shared-icon
    *ngIf="full && !property?.isFavorite"
    name="favorite-heart-black"
    [size]="iconSize"
  ></app-shared-icon>

  <app-shared-icon
    *ngIf="property?.isFavorite"
    name="favorite-heart-filled"
    [size]="iconSize"
  ></app-shared-icon>
</div>
